import React from 'react';
import ReactFacebookLogin, {
  ReactFacebookFailureResponse,
  ReactFacebookLoginInfo,
} from 'react-facebook-login';
import { ReactComponent as FacebookLogo } from 'assets/ic_facebook.svg';
import { useAppDispatch } from 'bootstrap/hooks';
import { socialLogin } from 'bootstrap/user/actions';

const FACEBOOK_CLIENT_ID = process.env.REACT_APP_FACEBOOK_CLIENT_ID || '';

type Props = {
  className?: string;
  onSuccess: (hasSubscription: boolean) => void;
  onError: (type: 'facebook', error: string) => void;
};

export const FacebookLoginButton = ({
  className,
  onSuccess,
  onError,
}: Props) => {
  const dispatch = useAppDispatch();

  const handleFacebookLogin = (
    response: ReactFacebookLoginInfo | ReactFacebookFailureResponse,
  ) => {
    const fbLoginInfo = response as any;
    if (fbLoginInfo.id) {
      dispatch(
        socialLogin(
          fbLoginInfo.first_name || '',
          fbLoginInfo.last_name || '',
          fbLoginInfo.email || '',
          fbLoginInfo.id,
          fbLoginInfo.accessToken,
          'facebook',
        ),
      )
        .then((hasSubscription) => {
          onSuccess(hasSubscription);
        })
        .catch((error) => {
          onError('facebook', error);
        });
    }
  };

  return (
    <ReactFacebookLogin
      appId={FACEBOOK_CLIENT_ID}
      fields="id,name,first_name,last_name,email"
      disableMobileRedirect={true}
      cssClass={className || 'social-login-button'}
      icon={<FacebookLogo />}
      callback={handleFacebookLogin}
    />
  );
};
